module.exports = __webpack_public_path__ + "img/BCHABC.80eddd1f.svg";